import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, of, switchMap } from 'rxjs';

import { ProductSortimentsPricingResponse } from '@app/api/marketplace/models';
import { PricingService } from '@app/api/marketplace/services';
import { SnackbarComponent } from '@shared/components/snackbar/snackbar.component';

import { SelectedProductsActions } from './selected-products.slice';

@Injectable({ providedIn: 'root' })
export class SelectedProductsEffects {
  loadSortiment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SelectedProductsActions.loadSelectedProducts.trigger),
      switchMap((action) =>
        this.pricingService
          .getProductSortimentsForPricing({ body: action.selectedProductIds })
          .pipe(
            map((response: Array<ProductSortimentsPricingResponse>) =>
              SelectedProductsActions.loadSelectedProducts.success({ response })
            ),
            catchError(() =>
              of(SelectedProductsActions.loadSelectedProducts.failure())
            )
          )
      )
    )
  );

  updatePrices$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SelectedProductsActions.updatePrices.trigger),
      switchMap((action) =>
        this.pricingService
          .updateProductSortimentEntryPrices({ body: action.data })
          .pipe(
            map((response) => {
              this.snackBar.openFromComponent(SnackbarComponent, {
                horizontalPosition: 'center',
                verticalPosition: 'bottom',
                duration: 3000,
                data: this.translateService.instant('PRICING.SAVE_SUCCESS'),
              });
              return SelectedProductsActions.updatePrices.success(response);
            }),
            catchError(() => of(SelectedProductsActions.updatePrices.failure()))
          )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly pricingService: PricingService,
    private readonly translateService: TranslateService,
    private readonly snackBar: MatSnackBar
  ) {}
}
